import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Activity } from "@shared/types";

export function useActivities(projectId: string) {
  return useQuery({
    queryKey: ["activities", projectId],
    queryFn: () => api.get<{ activities: Activity[] }>(`/projects/${projectId}/activities`),
    select: (d) => d.activities,
  });
}

export function useActivityMutations(projectId: string) {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ["activities", projectId] });
    qc.invalidateQueries({ queryKey: ["project", projectId] });
    qc.invalidateQueries({ queryKey: ["projects"] });
    qc.invalidateQueries({ queryKey: ["dashboard-portfolio"] });
    qc.invalidateQueries({ queryKey: ["tasks"] });
  };
  return {
    create: useMutation({ mutationFn: (b: any) => api.post("/activities", { ...b, projectId }), onSuccess: invalidate }),
    update: useMutation({ mutationFn: ({ id, ...b }: any) => api.put(`/activities/${id}`, b), onSuccess: invalidate }),
    status: useMutation({ mutationFn: ({ id, ...b }: any) => api.patch(`/activities/${id}/status`, b), onSuccess: invalidate }),
    custom: useMutation({ mutationFn: ({ id, values }: any) => api.put(`/activities/${id}/custom`, { values }), onSuccess: invalidate }),
    remove: useMutation({ mutationFn: (id: string) => api.del(`/activities/${id}`), onSuccess: invalidate }),
    reorder: useMutation({ mutationFn: (ids: string[]) => api.post("/activities/reorder", { projectId, ids }), onSuccess: invalidate }),
  };
}
